module.exports = __webpack_public_path__ + "fifoIllustration.webp?259f2b0f02ab9ad1e602bb503d00e65a";